import styled from 'styled-components';

export const ContentWrapper = styled.div`
    max-width: 1400px;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
`;

export const H1 = styled.h1`
    color: #003366;
    font-size: 32px;
    margin: 10px 0 15px 0;
`;

export const H2 = styled.h2`
    color: #003366;
    font-size: 24px;
    font-weight: bold;
    margin: 5px 0 10px 0;
`;

export const H3 = styled.h3`
    color: #003366;
    font-size: 16px;
    font-weight: bold;
    text-transform: uppercase;
    margin: 5px 0 10px 0;
`;

export const Article = styled.article`
    margin-bottom: 20px;
    &:last-of-type {
        margin-bottom: 10px;
    }
`;

export const More = styled.div`
    padding: 10px 20px;
    margin: auto;
    background-color: #003366;
    color: white;
    border-radius: 50px;
    margin-bottom: 10px;
    text-align: center;
    &:hover {
        background-color: #325b84;
    }
`;

export const Card = styled.div`
    display: flex;
    flex-direction: column;
    background-color: #F5F5F5;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    margin-left: 5px;
    margin-right: 5px;
    box-shadow: 0px 0px 4px 3px rgba(0,0,0,0.16);
    margin-bottom: 20px;
    @media screen and (min-width: 475px) {
        flex-basis: 300px;
    }
    @media screen and (min-width: 768px) {
        flex-basis: 400px;
    }

    h3 {
        padding: 5px 10px;
        text-align: center;
        text-transform: uppercase;
        color: #003366;
        font-size: 16px;
        font-weight: bold;
    }

    p {
        text-align: center;
        padding: 10px;
        margin-bottom: 0;
        padding-top: 5px;
    }

    img {
        width: 100%;
        margin-bottom: 10px;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }
`;

export const RouterWrapper = styled.div`
    @media screen and (min-width: 1280px) {
        max-width: 1024px;
        margin: auto;
    }
    div:first-of-type {

    }
    div:last-of-type {

    }
`;

export const PaddingWrapper = styled.div`
    padding: 15px;

    @media screen and (min-width: 1200px) {
        padding: 20px;
    }
`;
